import IMask from "imask";

export const IMaskDateblocks = {
  YYYY: {
    mask: IMask.MaskedRange,
    from: 1970,
    to: 2500,
  },
  MM: {
    mask: IMask.MaskedRange,
    from: 1,
    to: 12,
  },
  DD: {
    mask: IMask.MaskedRange,
    from: 1,
    to: 31,
  },
  HH: {
    mask: IMask.MaskedRange,
    from: 0,
    to: 23,
  },
  mm: {
    mask: IMask.MaskedRange,
    from: 0,
    to: 59,
  },
  ss: {
    mask: IMask.MaskedRange,
    from: 0,
    to: 59,
  }
}

export function getMinDateIMask() {
  //Month 0 to 11 index
  return new Date(IMaskDateblocks.YYYY.from, IMaskDateblocks.MM.from - 1, IMaskDateblocks.DD.from, IMaskDateblocks.HH.from, IMaskDateblocks.mm.from, IMaskDateblocks.ss.from);
}

export function getMaxDateIMask() {
  //Month 0 to 11 index
  return new Date(IMaskDateblocks.YYYY.to, IMaskDateblocks.MM.to - 1, IMaskDateblocks.DD.to, IMaskDateblocks.HH.to, IMaskDateblocks.mm.to, IMaskDateblocks.ss.to);
}
